import { FC } from 'react';
import { TripType } from '../../services/tripType';
import BusinessIcon from '../../assets/icons/business.svg?react';
import WorkIcon from '../../assets/icons/work.svg?react';
import LockIcon from '../../assets/icons/lock.svg?react';
import PrivateIcon from '../../assets/icons/private.svg?react';

interface TripTypeIconProps {
  tripType: TripType;
  className?: string;
}

export const TripTypeIcon: FC<TripTypeIconProps> = ({
  tripType,
  className,
}) => {
  switch (tripType) {
    case 'BUSINESS':
      return <BusinessIcon className={className} />;
    case 'WORK':
      return <WorkIcon className={className} />;
    case 'PRIVATE':
      return <LockIcon className={className} />;
    case 'NONE':
      return <PrivateIcon className={className} />;
    default:
      return null;
  }
};
